import { render, staticRenderFns } from "./SeriesCode.vue?vue&type=template&id=0648651c&scoped=true&"
import script from "./SeriesCode.vue?vue&type=script&lang=js&"
export * from "./SeriesCode.vue?vue&type=script&lang=js&"
import style0 from "./SeriesCode.vue?vue&type=style&index=0&id=0648651c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648651c",
  null
  
)

export default component.exports